import { render, staticRenderFns } from "./ZnAlpha.vue?vue&type=template&id=5bc6fc68&"
import script from "./ZnAlpha.vue?vue&type=script&lang=js&"
export * from "./ZnAlpha.vue?vue&type=script&lang=js&"
import style0 from "./ZnAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports